import Marquee from "react-fast-marquee";

const WORDS = ["Reliable", "Honest", "Professional", "Peace of Mind", "On Time"];

export const BrandMarquee = ({ dark = true }) => (
  <div
    className={`py-8 border-y ${dark ? "bg-navy-900 border-white/10" : "bg-white border-slate-200"}`}
    data-testid="brand-marquee"
  >
    <Marquee speed={40} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <div key={i} className="flex items-center">
          <span
            className={`font-display font-extrabold uppercase tracking-tight text-3xl md:text-5xl mx-8 ${
              dark ? "text-white" : "text-navy-900"
            }`}
          >
            {w}
          </span>
          <span className={`text-2xl md:text-4xl ${dark ? "text-navy-500" : "text-slate-300"}`}>✦</span>
        </div>
      ))}
    </Marquee>
  </div>
);
